(function () {
  'use strict';

  /* @ngdoc object
   * @name slipAllowanceReport
   * @description
   *
   */
  angular
    .module('simUtilizationReport', [
      'ui.router'
    ]);
}());
